import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, CardFooter, Spinner, Button } from "reactstrap";
import Badge from "reactstrap/lib/Badge";
import MachineStreams from "../components/MachineStreams";
import MachineResellerInfo from "../components/MachineResellerInfo";
import ConfigViewerModal from "../components/common/ConfigViewerModal";
import { getInferenceConfig } from "../services/configCenterService";
import { configViewerRoles } from "../components/shared/constants";
import { userHasAnyRole } from "../components/shared/utils/authUtils";
import { getInferenceMachine } from "../services/inferenceMachineService";
import setDocumentTitle from "../components/shared/utils/documentTitle";
import "../components/machines/InferenceMachineView.scss";
import SoftwareVersions from "../components/SoftwareVersions";
import DisableServerButton from "../components/machines/DisableServerButton";

class InferenceMachineDetailView extends React.Component {
  state = { machine: null, isConfigModalOpen: false };
  async componentDidMount() {
    const { match } = this.props;
    try {
      const { data: machine } = await getInferenceMachine(match.params.id);
      this.setState({ machine });
      setDocumentTitle(machine.machine.hostname);
    } catch (ex) {
      /* continue regardless of error */
    }
  }

  toggleConfigModal = () => {
    this.setState((prevState) => ({ isConfigModalOpen: !prevState.isConfigModalOpen }));
  };

  handleServerDisabled = () => {
    this.setState((prevState) => ({
      machine: {
        ...prevState.machine,
        machine: { ...prevState.machine.machine, passphrase_enabled: false },
      },
    }));
  };

  handleFetchInferenceConfig = () => {
    const { machine } = this.state;
    if (!machine) return Promise.resolve(null);
    return getInferenceConfig(machine.machine.hostname).then((r) => r.data);
  };

  render() {
    const { machine, isConfigModalOpen } = this.state;
    const canViewConfig = userHasAnyRole(configViewerRoles);
    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="mb-2">
                <h5 className="card-category">Inference Machine</h5>
                {machine && (
                  <React.Fragment>
                    <CardTitle tag="h2">{machine.machine.hostname}</CardTitle>
                    <div className="menu-bar">
                      <div className="menu-bar__left">
                        <Badge color="primary">{machine.machine.group}</Badge>
                        {canViewConfig && (
                          <Button color="secondary" onClick={this.toggleConfigModal}>
                            View config
                          </Button>
                        )}
                        <DisableServerButton machine={machine.machine} onDisabled={this.handleServerDisabled} />
                      </div>
                      {machine.machine.ip && (
                        <a href={`ssh://veesion@${machine.machine.ip}`}>
                          <Button>Connect</Button>
                        </a>
                      )}
                      {!machine.machine.ip && <Button disabled={!machine.machine.ip}>Connect</Button>}
                    </div>
                  </React.Fragment>
                )}
              </CardHeader>
              {machine && canViewConfig && (
                <ConfigViewerModal
                  isOpen={isConfigModalOpen}
                  toggle={this.toggleConfigModal}
                  title={`Inference config: ${machine.machine.hostname}`}
                  resourceId={machine.machine.hostname}
                  fetch={this.handleFetchInferenceConfig}
                  requestInfo={{
                    url: "/config-center/inference-configs/",
                    headers: { "X-Server-Hostname": machine.machine.hostname },
                  }}
                />
              )}
              <CardBody>
                {machine && (
                  <React.Fragment>
                    {machine.machine.cloud_identifier && (
                      <div className="cloud-identifier-info mb-3">
                        <i className="fas fa-cloud mr-2" />
                        <strong>{machine.machine.cloud_identifier}</strong>
                      </div>
                    )}
                    <MachineResellerInfo machineId={machine.machine.id} hostname={machine.machine.hostname} />
                    <SoftwareVersions hostname={machine.machine.hostname} />
                    <MachineStreams streams={machine.cameras} />
                  </React.Fragment>
                )}
                {!machine && <Spinner color="primary" />}
              </CardBody>
              <CardFooter />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default InferenceMachineDetailView;
